import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["children", "isDefault", "attrs"];

/*
 * @Author: wangshengqiang
 * @Date: 2021-04-22 13:56:30
 * @LastEditTime: 2021-07-19 16:22:35
 * @LastEditors: wangshengqiang
 * @Description:
 */
import React from 'react';
import classnames from 'classnames';
import { useLocalClick } from '@/components/Button'; // import { getLocalClick } from '@/components/EventBtn/handleEvent';

import './index.less';

const renderBy = status => node => {
  return status ? node : null;
};

const Title = /*#__PURE__*/React.forwardRef((props = {}, ref) => {
  const {
    children,
    isDefault,
    attrs
  } = props,
        others = _objectWithoutProperties(props, _excluded); // if (!isDefault) return null;
  // console.log('titlepropsformkey==>',props)


  const {
    subTitle,
    title
  } = attrs || {};
  const {
    enable,
    content,
    events = {}
  } = subTitle || {};
  const cls = classnames({
    'title-wrapper': true // [className]: !!className,
    // 'common-key-title': _name === 'common.title',

  }); // const onClick = getLocalClick(events);

  const onClick = useLocalClick(events);
  const descNode = renderBy(enable && content)( /*#__PURE__*/React.createElement("div", {
    className: "desc",
    onClick: onClick
  }, content));
  const titleNode = renderBy(title)( /*#__PURE__*/React.createElement("div", {
    className: "title-container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "title"
  }, title), descNode));
  return /*#__PURE__*/React.createElement("div", _extends({
    className: cls,
    ref: ref
  }, others), titleNode, children);
});
export default Title;